import { useCallback, useEffect } from 'react';

import { useAppSelector } from '../state';
import { track } from '../track';
import { useVisibilityChange } from './useVisibilityChange';

interface IUsePageViewParams {
  method?: 'send' | 'collect';
  payload?: { [key: string]: any };
  deps?: React.DependencyList;
  callback?: () => void;
}

const PAGE_VIEW_EVENT_NAME = 'page_view';

// 自定义 Hook: 用于发送页面曝光埋点
export const usePageView = (page: string, options?: IUsePageViewParams) => {
  const trackSourceData = useAppSelector((state) => state.global.trackSourceData);
  const { method = 'send', deps = [], payload = {}, callback } = options || {};

  const sendTracking = useCallback(() => {
    track?.[method](PAGE_VIEW_EVENT_NAME, page, {
      ...payload,
      ...(trackSourceData || {}),
    });
    callback?.();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [deps, callback]);

  // 初次加载时发送埋点
  useEffect(() => {
    sendTracking();
  }, []);

  // 页面可见性变化时发送埋点
  useVisibilityChange({ onVisible: sendTracking });
};
